<template>
  <div class="ReportSystem">
    <div class="page_img">
      <img src="@/assets/img/report_system.jpg" alt="">
    </div>
    <div class="page_content flex_row content">
      <div class="content_title summary_top">
        <img class="back_left" src="@/assets/img/scienceBorder_left.png" alt="">
        <img class="back_right" src="@/assets/img/scienceBorder_right.png" alt="">
        <div class="font_shadow page_summary">运营大数据智能报告系统</div>
      </div>
    </div>
    <div class="page_main flex_column main">
      <img src="@/assets/img/report_main.png" alt="">
      <div class="main_explain report_explain">现代企业面对激烈的市场竞争，专业技术和信息等瞬息万变，企业决策需要科学严谨的方法，如何应用大数据平台为企业发展运营的决策提供支持，决策者需要通过创新思维和差异化发展，找到新的战略</div>
      <img class="img2" src="@/assets/img/report_main1.png" alt="">
    </div>
    <div class="page_system flex_column system" v-for="items in list">
      <div class="sys_title flex_column system_title">
        <div class="system_summary">{{items.summary}}</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="sys_main system_main flex_row" v-for="item in items.item">
        <div class="system_left sys_left flex_row">
          <img :src="item.src" alt="">
        </div>
        <div class="sys_right system_right">
          <div class="title report_title font_shadow">{{item.title}}</div>
          <div class="info report_info">{{item.info}}</div>
          <div class="tag report_tag" v-for="tag in item.tag"><span></span>{{tag}}</div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import softTop from "@/components/pc/softTop";
import bottom from "@/components/pc/bottom";
export default {
  name: 'ReportSystem',
  components: {
    softTop,
    bottom
  },
  data() {
    return {
      list: [],
    }
  },
  created() {
    let list = [
      {
        summary: '运营管理中心',
        item: [
          {
            src: 'https://www.visumall.com/public/img/report_content1.png',
            title: '运营决策模块',
            info: 'VISUALL平台的管理后台实时监控门店状态',
            tag: ['大数据统计分析，量化决策体系，运营管理和发展方向更科学']
          },
          {
            src: 'https://www.visumall.com/public/img/report_content3.png',
            title: '营销AI数据模型',
            info: 'VISUALL平台个性化定制门店分享内容',
            tag: ['实时帮助门店门诊增加客流量并增强粘性，实现低成本拉新获客']
          },
        ]
      },
      {
        summary: '眼健康中心的后端运营管理智能化',
        item: [
          {
            src: 'https://www.visumall.com/public/img/report_content2.png',
            title: '产品推荐管理',
            info: '通过统计分析产品的营销状况进行门店货品及管理的及时调整与跟踪',
            tag: []
          },
          {
            src: 'https://www.visumall.com/public/img/report_content4.png',
            title: 'C2M垂直体验中心',
            info: '在VISUMALL平台里的全球所有视光产品库中推荐出最适合顾客需求的智能处方产品',
            tag: []
          },
        ]
      }
    ];
    this.list = list;
  },
}
</script>

<style scoped lang="scss">
.ReportSystem {
  .content {
    margin: 0.4rem 0 1.5rem;
  }
  .main {
    width: 100%;
    margin-bottom: 1.3rem;
    img {
      width: 50%;
    }
    .img2 {
      width: 55%;
    }
    .report_explain {
      text-align: left;
      margin: 1rem 0 1rem;
      width: 65%;
      padding: 0.25rem 0.45rem;
      font-size: 0.19rem;
      font-weight: 500;
    }
  }
  .system {
    margin-bottom: 1.3rem;
    .system_title {
      .system_summary {
        font-size: 0.3rem;
        font-weight: bold;
        text-align: center;
      }
    }
    .system_main1 {
      margin-top: 0.8rem;
      img {
        width: 60%;
      }
    }
    .sys_main {
      margin-top: 0.8rem;
      .system_left {
        flex: 1;
        img {
          width: 60%;
        }
      }
      .system_right {
        flex: 1;
        margin-top: 0.2rem;
        .report_title {
          font-size: 0.25rem;
        }
        .report_info {
          width: 70%;
          margin-top: 0.22rem;
          font-size: 0.19rem;
        }
        .report_tag {
          position: relative;
          padding-left: 0.25rem;
          width: 60%;
          margin-top: 0.15rem;
          font-size: 0.19rem;
          span {
            position: absolute;
            left: 0;
            top: 0;
            transform: translate(50%,50%);
            width: 0.12rem;
            height: 0.12rem;
            background: #999;
          }
        }
      }
    }
  }

}
</style>
